import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { WalletIcon, getWalletPrimaryColor } from '@dynamic-labs/wallet-book';
import { useThemeContext } from '../../context/ThemeContext/ThemeContext.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../components/IconButton/IconButton.js';
import { PoweredByDynamic } from '../../components/PoweredByDynamic/PoweredByDynamic.js';
import { useQrCodeContext } from '../../context/QrCodeContext/QrCodeContext.js';
import { QrCodeContainer } from './QrCodeContainer/QrCodeContainer.js';

const QrCodeView = () => {
    var _a;
    const { theme: { theme }, } = useThemeContext();
    const { name } = theme;
    const { setShowQrCodeMessage } = useQrCodeContext();
    const { qrcodeUri, desktopUri, selectedWalletConnector: walletConnector, termsOfServiceUrl, privacyPolicyUrl, } = useInternalDynamicContext();
    useEffect(() => {
        setTimeout(() => {
            setShowQrCodeMessage(true);
        }, 5000);
    }, [setShowQrCodeMessage]);
    if (!walletConnector) {
        return null;
    }
    const icon = (jsx(WalletIcon, { walletName: walletConnector.name, style: { height: pixelToRem(32), width: pixelToRem(32) } }));
    return (jsxs("div", Object.assign({ className: 'qr-code-view__container', "data-testid": 'qr-code-view' }, { children: [jsx(QrCodeContainer, { desktopUri: desktopUri, accentColor: 
                /* istanbul ignore next */
                name === 'dark'
                    ? theme.colors.textPrimary
                    : (_a = getWalletPrimaryColor(walletConnector.name)) !== null && _a !== void 0 ? _a : '', walletName: walletConnector.name, qrcodeValue: qrcodeUri, Icon: icon, privacyPolicyUrl: privacyPolicyUrl, termsOfServiceUrl: termsOfServiceUrl, showCopyToClipboardButton: walletConnector.isWalletConnect }), jsx(PoweredByDynamic, { classNameRoot: 'qr-code-view__powered-by' })] })));
};

export { QrCodeView };
